/**
 * Wishlist: localStorage-backed favorites list.
 * Works via event delegation so it needs no per-card wiring - any element
 * with [data-wishlist-toggle][data-product-handle] anywhere in the DOM
 * (including content injected later, e.g. filtered collection grids)
 * is picked up automatically.
 */
(function () {
  var STORAGE_KEY = 'mostre_wishlist';
  var EMPTY_TEXT = 'Nu ai salvat încă niciun parfum.';

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private browsing, quota) - fail silently, toggling still works for this page view */
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isSaved(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setList(list);
    return idx === -1; // true if it was just added
  }

  function remove(handle) {
    var list = getList().filter(function (h) {
      return h !== handle;
    });
    setList(list);
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var saved = isSaved(handle);
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      saved ? 'Elimină din produse favorite' : 'Adaugă la produse favorite'
    );
  }

  function syncAllButtons() {
    document
      .querySelectorAll('[data-wishlist-toggle][data-product-handle]')
      .forEach(syncButtonState);
    syncHeaderBadge();
  }

  function syncHeaderBadge() {
    var count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-toggle][data-product-handle]');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    var justAdded = toggle(handle);
    document
      .querySelectorAll(
        '[data-wishlist-toggle][data-product-handle="' + CSS.escape(handle) + '"]'
      )
      .forEach(syncButtonState);
    syncHeaderBadge();

    if (justAdded) {
      btn.classList.add('wishlist-pop');
      setTimeout(function () {
        btn.classList.remove('wishlist-pop');
      }, 260);
    }
  });

  document.addEventListener('DOMContentLoaded', syncAllButtons);
  if (document.readyState !== 'loading') syncAllButtons();
  document.addEventListener('wishlist:list-remove', function (e) {
    remove(e.detail.handle);
  });

  // --- Wishlist page rendering (only runs where a container is present) ---
  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    var grid = container.querySelector('[data-wishlist-grid]');
    var emptyState = container.querySelector('[data-wishlist-empty]');
    var handles = getList();

    if (!handles.length) {
      grid.innerHTML = '';
      emptyState.hidden = false;
      emptyState.textContent = EMPTY_TEXT;
      return;
    }
    emptyState.hidden = true;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = '';
      var anyValid = false;
      products.forEach(function (product, i) {
        if (!product) {
          // product was removed/unpublished since being saved - drop it silently
          remove(handles[i]);
          return;
        }
        anyValid = true;
        grid.appendChild(buildCard(product));
      });
      if (!anyValid) {
        emptyState.hidden = false;
        emptyState.textContent = EMPTY_TEXT;
      }
    });
  }

  function buildCard(product) {
    var card = document.createElement('div');
    card.className = 'wishlist-card';
    card.style.cssText =
      'position:relative;border:1px solid rgb(0 0 0 / 0.08);border-radius:16px;padding:16px;';

    var image = product.featured_image || (product.images && product.images[0]) || '';
    var priceMin = Math.min.apply(
      null,
      product.variants.map(function (v) {
        return v.price;
      })
    );

    var sizePills = product.variants
      .map(function (v) {
        return (
          '<a href="/products/' +
          product.handle +
          '?variant=' +
          v.id +
          '" style="font-size:0.7rem;padding:2px 10px;border:1px solid rgb(0 0 0 / 0.2);border-radius:999px;color:rgb(0 0 0 / 0.85);text-decoration:none;">' +
          v.public_title +
          '</a>'
        );
      })
      .join('');

    card.innerHTML =
      '<button type="button" class="pdp-card-wishlist is-active" data-wishlist-toggle data-product-handle="' +
      product.handle +
      '" aria-label="Elimină din produse favorite" style="position:absolute;top:24px;right:24px;background:none;border:none;cursor:pointer;padding:4px;line-height:0;"></button>' +
      '<a href="/products/' +
      product.handle +
      '" style="display:block;border-radius:12px;overflow:hidden;background:#f5f5f4;aspect-ratio:1;margin-bottom:10px;">' +
      (image
        ? '<img src="' +
          image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') +
          '" alt="' +
          (product.featured_image ? product.title : '') +
          '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
        : '') +
      '</a>' +
      (product.vendor
        ? '<p style="margin:0;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.04em;color:rgb(0 0 0 / 0.7);">' +
          product.vendor +
          '</p>'
        : '') +
      '<a href="/products/' +
      product.handle +
      '" style="display:block;font-size:0.95rem;margin:2px 0 0;color:inherit;text-decoration:none;">' +
      product.title +
      '</a>' +
      '<div style="display:flex;gap:6px;flex-wrap:wrap;margin:4px 0;">' +
      sizePills +
      '</div>' +
      '<a href="/products/' +
      product.handle +
      '" style="display:block;text-align:center;background:#000;color:#fff;border-radius:999px;padding:9px 18px;font-size:0.85rem;font-weight:600;text-decoration:none;margin-top:8px;">De la ' +
      (priceMin / 100).toFixed(2).replace('.', ',') +
      ' lei</a>';

    var removeBtn = card.querySelector('[data-wishlist-toggle]');
    // Heart SVG matches snippets/icon-heart.liquid so the remove control looks identical
    // to the save control everywhere else on the site.
    removeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
    removeBtn.style.color = '#c0392b';

    return card;
  }

  document.addEventListener('DOMContentLoaded', renderWishlistPage);
  if (document.readyState !== 'loading') renderWishlistPage();
  document.addEventListener('wishlist:updated', function () {
    if (document.querySelector('[data-wishlist-page]')) renderWishlistPage();
  });
})();
